import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  InputGroup,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  InputLeftAddon,
  InputRightAddon,
  Flex
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const schemaRegisterTag = z.object({
  nomeTag: z.string().min(3, 'O nome deve conter no mínimo 3 caracteres'),
  linkTag: z
    .string()
    .min(5, 'O link deve conter no mínimo 5 caracteres')
    .transform((value) => {
      if (!value.startsWith('https://')) {
        return `https://${value}`;
      }
      return value;
    })
});

export function CadastrarTag() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: zodResolver(schemaRegisterTag)
  });

  async function onSubmit(data) {
    console.log(data);
  }

  return (
    <>
      <Button size="sm" my={2} colorScheme="blue" onClick={onOpen}>
        Cadastrar nova Tag.
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cadastrar nova Tag</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl isInvalid={errors.nomeTag}>
                <FormLabel htmlFor="nomeTag">Nome da Tag</FormLabel>
                <Input size="sm" id="nomeTag" placeholder="nomeTag" {...register('nomeTag')} />
                <FormErrorMessage>{errors.nomeTag && errors.nomeTag.message}</FormErrorMessage>
              </FormControl>
              <FormControl mt={2} isInvalid={errors.linkTag}>
                <FormLabel htmlFor="linkTag">Link da Tag</FormLabel>
                <InputGroup size="sm">
                  <InputLeftAddon>https://</InputLeftAddon>
                  <Input id="linkTag" placeholder="linkTag" {...register('linkTag')} />
                </InputGroup>
                <FormErrorMessage>{errors.linkTag && errors.linkTag.message}</FormErrorMessage>
              </FormControl>
              <Flex
                mt={4}
                justifyContent="flex-end"
                alignItems="center"
                flexDirection="row"
                gap={2}>
                <Button mt={4} colorScheme="blue" isLoading={isSubmitting} type="submit">
                  Confirmar
                </Button>
                <Button mt={4} ml={2} colorScheme="red" onClick={onClose}>
                  Cancelar
                </Button>
              </Flex>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
